<template>
  <v-card class="dados-gerais-container">
    <div class="dados-gerais-panel-header">
      <h4 class="titulo">Ficha médica</h4>
    </div>
    <v-card-text v-if="dadosFichaPaciente">
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="mt-5">
          <campo-text-area-editavel
              v-model="dadosFichaPaciente.outrasInformacoesImportantes"
              label="Informações importantes"
              name="informações importantes"
              :validate="{max: 500}"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pt-5">
          <campo-check-box-editavel
              v-model="dadosFichaPaciente"
              :label="'História médica'"
              :name="'check-box'"
              @submitEvent="tratarEventoSalvarCheckBox"
          />
        </v-col>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.tratamento"
              :label="'Está fazendo tratamento médico'"
              :name="'esta-fazendo-tratamento'"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-de-texto-editavel
              v-model="dadosFichaPaciente.outrosMedicamentos"
              label="Outros medicamentos"
              name="outros_medicamentos"
              :maxlength="250"
              :counter="250"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.anestesiaLocal"
              label="Já fez uso de anestesia local?"
              name="uso-anestesia-local"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.possuiReacaoAnestesiaLocal"
              label="Em caso positivo, já sentiu alguma reação?"
              name="caso-positivo-anestesia"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.usoAntibiotico"
              label="Já fez uso de penicilina ou outros antibióticos?"
              name="uso-antibiotico"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.possuiReacaoAntibiotico"
              label="Em caso positivo, já sentiu alguma reação?"
              name="caso-positivo-antibiotico"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-de-texto-editavel
              v-model="dadosFichaPaciente.nomeAntibiotico"
              label="Nome do antibótico que houve reação"
              name="nome_antibiotico"
              :maxlength="150"
              :counter="150"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-de-texto-editavel
              v-model="dadosFichaPaciente.nomeMedicamentoAlergia"
              label="Possui alergia a algum medicamento?"
              name="nome_medicamento_alergia"
              :maxlength="250"
              :counter="250"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.cicatrizacaoNormal"
              label="Quando se fere, o sangramento e a cicatrização são normais?"
              name="cicatrizacao-normal"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12">
          <campo-de-texto-editavel
              v-model="dadosFichaPaciente.tiqueMania"
              label="Possui algum tique ou mania?"
              name="qual-tique-mania"
              :maxlength="250"
              :counter="250"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.estaGravida"
              label="Está gravida?"
              name="esta-gravida"
              @input="tratarEventoSalvar"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="12">
          <campo-radio-group-editavel
              v-model="dadosFichaPaciente.fumante"
              label="É fumante?"
              name="fumante"
              @input="tratarEventoSalvar"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {actionTypes} from '@/core/constants'
import tipoPaciente from '@/core/constants/enums/tipoPaciente'
import CampoCheckBoxEditavel from '@/views/components/camposEditaveis/campo-check-box-editavel.vue'
import CampoRadioGroupEditavel from '@/views/components/camposEditaveis/campo-radio-group-editavel.vue'
import CampoDeTextoEditavel from '@/views/components/camposEditaveis/campo-texto-editavel.vue'
import CampoTextAreaEditavel from '@/views/components/camposEditaveis/campo-text-area-editavel.vue'

export default {
    name: 'PacienteFichaMedica',
    components: {CampoTextAreaEditavel, CampoDeTextoEditavel, CampoRadioGroupEditavel, CampoCheckBoxEditavel},

    data() {
        return {
            pacienteId: null,
            dadosFichaPaciente: null,
            exibirPanel: 1,
            tipoPaciente
        }
    },
    async mounted() {
        this.setarPacienteId()
        await this.buscarFicha()
    },
    methods: {
        setarPacienteId() {
            if (this.$route.params.id) {
                this.pacienteId = this.$route.params.id
            }
        },
        async buscarFicha() {
            const resposta = await this.$store.dispatch(actionTypes.CADASTROS.PACIENTE.FICHA.BUSCAR_POR_PACIENTE, this.pacienteId)
            if (resposta) {
                this.dadosFichaPaciente = resposta
            }
        },
        async tratarEventoSalvar() {
            const input = {...this.dadosFichaPaciente, pacienteId: this.pacienteId}
            if (input.id) {
                await this.$store.dispatch(actionTypes.CADASTROS.PACIENTE.FICHA.EDITAR_FICHA, input)
            } else {
                const resposta = await this.$store.dispatch(actionTypes.CADASTROS.PACIENTE.FICHA.CADASTRAR_FICHA, input)
                if (resposta) {
                    this.dadosFichaPaciente.id = resposta.fichaPacienteId
                }
            }
        },
        async tratarEventoSalvarCheckBox(dados) {
            this.dadosFichaPaciente = {...this.dadosFichaPaciente, ...dados}
            await this.tratarEventoSalvar()
        }
    }
}
</script>

<style scoped lang="stylus">
.dados-gerais-container
  border solid 1px #e7e7e7
  border-radius 5px

.dados-gerais-panel-header
  border-bottom solid 1px #e7e7e7
  background-color #F6F6F6
  border-radius 5px
  border-bottom-right-radius 0
  border-bottom-left-radius 0
  padding 10px

.titulo
  font-size 15px
  font-weight bold
  color #777

.label
  font-size 13px
  font-weight bold
  color #777

.texto
  font-size 13px
  color #777

</style>
